export const BASE_FLOW = [
  "welcome",
  "company",
  "chooseAI",
  "training",
  "test",
  "ready",
  "whatsapp",
  "finish"
];

export const SALES_FLOW = [
  "welcome",
  "company",
  "chooseAI",
  "catalog",
  "payment",
  "training",
  "test",
  "ready",
  "whatsapp",
  "finish"
];

export const SCHEDULING_FLOW = [
  "welcome",
  "company",
  "chooseAI",
  "schedulingServices",
  "schedulingProfessionals",
  "schedulingAvailability",
  "training",
  "test",
  "ready",
  "whatsapp",
  "finish"
];

export const getFlowSteps = objective => {
  if (objective === "vendas") {
    return SALES_FLOW;
  }

  if (objective === "agendamento") {
    return SCHEDULING_FLOW;
  }

  return BASE_FLOW;
};

export const getFlowMaxStep = objective =>
  getFlowSteps(objective).length - 1;
